const Text = ({ className = undefined, children }: TextProps) => (
  <span className={className}>
    <span>{children}</span>
  </span>
);

interface TextProps {
  className?: string;
  children: string;
}

export default Text;
